import { createContext, useContext } from 'react';
import { useConversationsList } from '../hooks/useConversationsList';
import { jsx as _jsx } from "react/jsx-runtime";
const ConversationListContext = /*#__PURE__*/createContext(null);
export const useConversationList = () => {
  const context = useContext(ConversationListContext);
  if (!context) {
    throw new Error('useConversationList must be used within a ConversationListProvider');
  }
  return context;
};
export const ConversationListProvider = ({
  agentId,
  children
}) => {
  const state = useConversationsList(agentId);
  return /*#__PURE__*/_jsx(ConversationListContext.Provider, {
    value: state,
    children: children
  });
};